import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useChatBot } from '../utils/chatbotUtils';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsWideStep } from '../hooks/useIsWideStep';
import { getActiveLoading } from '../store/loading-status/selectors';
import { Wave } from '../wave/Wave';
import { AppMessagingComponent } from './AppMessagingComponent';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { BackLink } from '../views-components/BackLink';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { ContentHolder, FlowStep, FlowStepComponent, ViewComponent } from './AppViewComponent.styles';
export const AppViewComponent = ({
  StepViewComponent
}) => {
  const {
    isAssignedToVariant: isAssignedToVariant127
  } = useExperiment(ExperimentKeys.ACQ127, TrackWhen.never);
  useChatBot(isAssignedToVariant127);
  const {
    isWideStep,
    waveType
  } = useIsWideStep();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    currentStep
  } = useCurrentStep();
  const activeLoading = useSelector(getActiveLoading);
  const {
    isMobile
  } = useResponsiveness();
  const showBackLink = isFramedCentredStep && !isMobile;
  return /*#__PURE__*/_jsxs(ViewComponent, {
    isFramedCentredStep: isFramedCentredStep,
    isWideStep: isWideStep,
    children: [/*#__PURE__*/_jsx(FlowStep, {
      children: /*#__PURE__*/_jsx(FlowStepComponent, {
        className: "FlowStepComponent",
        "data-loading": Boolean(activeLoading),
        "data-step": currentStep,
        children: /*#__PURE__*/_jsxs(ContentHolder, {
          isFramedCentredStep: isFramedCentredStep,
          isWideStep: isWideStep,
          children: [showBackLink && /*#__PURE__*/_jsx(BackLink, {}), isFramedCentredStep && /*#__PURE__*/_jsx(AppMessagingComponent, {}), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx(UILoadingSpinner, {
              grow: true,
              size: "extra-small"
            }),
            children: /*#__PURE__*/_jsx(StepViewComponent, {})
          }), waveType && /*#__PURE__*/_jsx(Wave, {
            type: waveType
          })]
        })
      })
    }), !isFramedCentredStep && /*#__PURE__*/_jsx(AppMessagingComponent, {})]
  });
};